import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FilterService {

    isVeg$ = new BehaviorSubject(false);

    constructor() {

    }

    toggleVeg(is_veg: boolean = false) {
        this.isVeg$.next(is_veg);
    }
}